/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { Select } from 'antd';

import { useNavigate } from 'react-router-dom';
import { Breadcrumb } from '../../components';
import { Row, Col, Alert, Spin } from 'antd';
import detailImg1 from '../../assets/images/detail-img1.png';
import detailImg2 from '../../assets/images/detail-img2.png';
import fileIcon from '../../assets/images/excelIcon.png';
import arrowDown from '../../assets/images/DownArrow.svg';
import arrowLeft from '../../assets/images/ArrowLeft.png';
import { formatFileSize } from 'react-papaparse';
import Delete from '../../assets/images/Delete.png';
import { RcFile } from 'antd/lib/upload';
import SupplierApi from '../../redux/middleware/supplier';
import Utils from '../../redux/utils';
import { checkAuthentication } from '../../helper/checkAuthentication';
import './BulkUploadSupplyIngredient.scss';

const BulkUploadSupplyIngredient = () => {
  const user = Utils.getCurrentUser();
  const navigate = useNavigate();
  const fileRef = React.useRef<HTMLInputElement>(null);

  const [tableData, setTableData] = useState<any>('');
  const [hideBtn, setHideBtn] = useState(false);
  const [errorList, setErrorList] = useState<any>('');
  const [visible, setVisible] = useState(false);
  const [loader, setLoader] = useState(false);
  const [showAllErrors, setShowAllErrors] = useState(false);

  React.useEffect(() => {
    checkAuthentication(user, navigate);
  }, []);

  const screenPermission = Utils.getScreenPermission('Supplier List');
  const validateActionPermission = () => {
    // Always allow file upload for Supplier List permission, matching supplier creation logic
    if (screenPermission) {
      return true;
    }
    return true;
  };

  const handleImage = (url: any, data: any) => {
    setTableData(data?.target?.files[0]);
  };

  const handleBack = () => {
    navigate('/app/supply');
  };

  const getBase64 = (file: RcFile): Promise<string> =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = (error) => reject(error);
    });

  const handleContinue = async () => {
    try {
      setLoader(true);
      setVisible(false);
      // Use current shop from Utils for upload
      const shopId = Utils.getCurrentShop()?.shop_id || null;
      const response = await SupplierApi.bulkTagIngredientsToSupplier(tableData, shopId);
      setLoader(false);
      if (!response?.success || response == undefined) {
        setTableData('');
        if (response != undefined) {
          if (response.error) {
            setErrorList(response.error);
          } else if (response.data?.messages) {
            setErrorList({ messages: response.data.messages });
          } else {
            setErrorList({ messages: ['Upload failed. Please check your CSV file.'] });
          }
        }
        if (response?.error?.messages?.length <= 3) {
          setHideBtn(true);
        } else {
          setHideBtn(false);
        }
      } else {
        const errorCount = response?.data?.error_count || 0;
        const messages = response?.data?.messages || [];
        if (errorCount > 0) {
          setErrorList({ messages: messages });
          setTableData('');
          if (messages.length <= 3) {
            setHideBtn(true);
          } else {
            setHideBtn(false);
          }
        } else {
          navigate('/app/supply');
          setTableData('');
        }
      }
    } catch (e) {
      setLoader(false);
      console.log(e);
    }
  };

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 24 }}>
        <Breadcrumb
          heading="Ingredients"
          breadcrumbIcon
          iconAction={() => {
            navigate('/app/supply');
          }}
          perm_status={screenPermission?.perm_status_id}
        />
        <button
          style={{ background: '#FFC727', color: '#212121', border: 'none', borderRadius: 24, padding: '10px 32px', fontWeight: 600, fontSize: 16, cursor: 'pointer' }}
          onClick={() => {
            const csvContent =
              'Item Name,Supplier Name,Unit Cost (Per Kg or Ltr or Piece)\n' +
              'Wrapped Black Curved Lollipops,Saad Co.,0.0024\n' +
              'Transparent Nylon Gloves,Saad Co.,0.0025\n' +
              'Sandwich Wrapping Paper Snack,Saad Co.,0.0038\n';
            const blob = new Blob([csvContent], { type: 'text/csv' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'supplier_ingredients_sample.csv';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
          }}
        >
          Download Sample CSV
        </button>
      </div>

      <Row>
        <Col lg={24} md={24}>
          {/* Shop/Branch dropdown removed. Shop is now always taken from Utils.getCurrentShop() */}
          {visible && (
            <Alert
              message="Error"
              description={
                'File format is Invalid. Please Select Correct File!'
              }
              type="error"
              showIcon
              closable
              className="wizardAlert"
              afterClose={() => setVisible(false)}
            />
          )}
          <Spin spinning={loader} size="large">
            <div className="BulkUploadSupplyIngredient">
              <div className="wizardSubContainer checkBox">
                <div className="wizardLabel">File Attachment</div>

                {tableData ? (
                  <div className="imageUpload">
                    <div className="imageWrapper">
                      <div>
                        <img src={fileIcon} alt="" style={{ width: '100%' }} />
                        <h4> {tableData?.name} </h4>
                        <p>{formatFileSize(tableData?.size)}</p>
                      </div>
                      <div
                        className="deleteButton"
                        onClick={() => handleImage('', [])}
                      >
                        <img src={Delete} width={15} alt="" />
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="formgroup formgroupStepOne">
                    <div className="label-wrapper">
                      <label>
                        <p className="ant-upload-text ">
                          Drop your csv file here or browse
                        </p>
                        <p className="ant-upload-hint">
                          {`Minimum file 2 MB (.csv)`}
                        </p>
                        <input
                          ref={fileRef}
                          type="file"
                          accept=".csv"
                          onChange={async (e: any) => {
                            const file = e.currentTarget.files[0];
                            if (file) {
                              if (file.type === 'text/csv' || 
                                  file.type === 'application/vnd.ms-excel' ||
                                  file.name.endsWith('.csv')) {
                                const response = await getBase64(file);
                                if (response) handleImage(response, e);
                              } else {
                                setVisible(true);
                              }
                            }
                          }}
                          disabled={!validateActionPermission()}
                        />
                      </label>
                    </div>
                  </div>
                )}
                {errorList &&
                  (Utils.renderErrorItem(errorList)?.length <= 3 ? (
                    <div className="ErrorContainer">
                      {Utils.renderErrorItem(errorList)?.map(
                        (error: any, index: any) => (
                          <p
                            className={
                              error.includes('Success') || error.includes('successfully')
                                ? 'SuccessContainerRDRecipe'
                                : ''
                            }
                            key={index}
                          >
                            {error}
                          </p>
                        )
                      )}
                    </div>
                  ) : (
                    <div className="ErrorContainer">
                      {Utils.renderErrorItem(errorList)
                        ?.slice(0, 3)
                        .map((error: any, index: any) => (
                          <p
                            className={
                              error.includes('Success') || error.includes('successfully')
                                ? 'SuccessContainerRDRecipe'
                                : ''
                            }
                            key={index}
                          >
                            {error}
                          </p>
                        ))}
                      {showAllErrors && (
                        <div>
                          {Utils.renderErrorItem(errorList)
                            ?.slice(3)
                            .map((error: any, index: any) => (
                              <p
                                className={
                                  error.includes('Success') || error.includes('successfully')
                                    ? 'SuccessContainerRDRecipe'
                                    : ''
                                }
                                key={index}
                              >
                                {error}
                              </p>
                            ))}
                        </div>
                      )}
                      <div>
                        <div
                          className="wizard-button upload-errors"
                          onClick={() => setShowAllErrors(!showAllErrors)}
                          hidden={hideBtn}
                        >
                          {showAllErrors ? 'Hide' : 'Show more'}
                          <img
                            src={showAllErrors ? arrowDown : arrowLeft}
                            alt={
                              showAllErrors ? 'Expand Icon' : 'Collapse Icon'
                            }
                            className={`expand-icon-bulk ${
                              showAllErrors ? 'arrow-down' : ''
                            }`}
                          />
                        </div>
                      </div>
                    </div>
                  ))}
                <div className="butonGroup">
                  <div className="wizard-button" onClick={handleBack}>
                    Back
                  </div>
                  <div
                    className="continue wizard-button"
                    onClick={handleContinue}
                  >
                    Continue
                  </div>
                </div>
              </div>
            </div>
          </Spin>
        </Col>
        <Col lg={12} md={24} style={{ display: 'none' }}>
          <div className="fileDetailBlockRDSubRecipe">
            <ol className="fileDetailListSupplyIngredient">
              <li>
                <div className="list-contentRD-SubRecipe">
                  <span>1.</span>
                  <p>
                    Download <b>CSV File</b>, you can choose <b>CSV Minimal</b>{' '}
                    or
                    <b>CSV Full</b>
                  </p>
                </div>
              </li>
              <li>
                <div className="list-contentRD-SubRecipe">
                  <span>2.</span>
                  <p>
                    Download <b>Get Marketlist</b> File
                  </p>
                </div>
              </li>
              <li>
                <div className="list-contentRD-SubRecipe">
                  <span>3.</span>
                  <p>
                    Open the <b>CSV File</b> and Input ingredients based on
                    <b>The Marketlist Data</b>. Make sure the ingredients is
                    suitable with the
                    <b>Marketlist Data</b>.
                  </p>
                </div>

                <div className="listImgSupplyIngredient">
                  <Row>
                    <div className="imgWrapper-SupplyIngredient">
                      <img src={detailImg1} alt="" />
                    </div>
                    <div className="imgWrapper-SupplyIngredient">
                      <img src={detailImg2} alt="" />
                    </div>
                  </Row>
                </div>
              </li>
              <li>
                <div className="list-contentRD-SubRecipe">
                  <span>4.</span>
                  <p>
                    Upload the <b>CSV File</b> on the
                    <b>Upload Recipes's Menu Download</b>
                  </p>
                </div>
              </li>
            </ol>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default BulkUploadSupplyIngredient;
